export default __webpack_public_path__ + "static/media/lipstick1.f0db1fec.jpg";